'use client';

import { styled } from '@linaria/react';

import { random } from '@/utils';

import Sparkles from '@/components/Sparkles';

const trophySrc = '/images/illustrations/gold-trophy.png';
const flameSpritesheetSrc =
  '/images/illustrations/gold-trophy-flames.png';

function generateSparklePosition() {
  return {
    top: random(30, 60) + '%',
    left: random(25, 75) + '%',
    zIndex: 2,
  };
}

const GoldTrophy = ({ size = 190, includeSparkles = true }) => {
  let content = (
    <Wrapper style={{ width: size, height: size * (800 / 380) }}>
      <picture>
        <source
          type="image/avif"
          srcSet={flameSpritesheetSrc.replace('.png', '.avif')}
        />
        <source type="image/png" srcSet={flameSpritesheetSrc} />
        <Sprite src={flameSpritesheetSrc} alt="" />
      </picture>
      <picture>
        <source
          type="image/avif"
          srcSet={trophySrc.replace('.png', '.avif')}
        />
        <source type="image/png" srcSet={trophySrc} />
        <Trophy
          src={trophySrc}
          alt="A shiny gold trophy with a diamond and blue flames"
        />
      </picture>
    </Wrapper>
  );

  if (!includeSparkles) {
    return content;
  }

  return (
    <Sparkles
      colors={['white']}
      minSize={size * 0.25}
      maxSize={size * 0.4}
      rate={1200}
      variance={800}
      generatePosition={generateSparklePosition}
      isToggleable={false}
      style={{ display: 'block' }}
    >
      {content}
    </Sparkles>
  );
};

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

const Sprite = styled.img`
  display: block;
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  @keyframes sprite {
    from {
      object-position: 0% 0%;
    }
    to {
      object-position: 100% 0%;
    }
  }

  animation: sprite steps(5, jump-none) 1000ms infinite;
`;

const Trophy = styled.img`
  display: block;
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
`;

export default GoldTrophy;
